import {Component, OnInit, ViewChild} from '@angular/core';
import {TextPatternService} from '../../../services/text/text-pattern.service';
import {ActivatedRoute} from '@angular/router';
import {TextPatternCreationDto} from '../../../dtos/text/text-pattern-dto';
import {NotificationService} from '../../../services/common/notification.service';
import {AuthService} from '../../../services/auth/auth.service';
import {References} from "../../../dtos/references";
import {SharedService} from "../../../services/common/shared.service";
import {TextPattern} from "../../../dtos/text/text-pattern";
import {FormOptionsLists} from "../../../shared/FormOptionsLists";
import {FormControl, UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {MarkdownEditorComponent} from "../../common/markdown-editor/markdown-editor.component";

@Component({
  selector: 'app-text-pattern-detail',
  templateUrl: './text-pattern-detail.component.html',
  styleUrls: ['./text-pattern-detail.component.scss'],
  standalone: false
})
export class TextPatternDetailComponent implements OnInit {
  @ViewChild(MarkdownEditorComponent) markdownEditor!: MarkdownEditorComponent;

  currentPatternId: number;
  textPattern: TextPattern;
  displayEditingTools = false;
  references: References;

  formOptionsLists = new FormOptionsLists();
  modesList = this.formOptionsLists.modes;

  formGroup: UntypedFormGroup;
  contentCtrl: FormControl;


  constructor(private textPatternService: TextPatternService,
              public authService: AuthService,
              private route: ActivatedRoute,
              private notificationService: NotificationService,
              private fb: UntypedFormBuilder,
              public sharedService: SharedService) {
  }

  ngOnInit() {
    this.contentCtrl = new FormControl('');
    this.formGroup = this.fb.group({
      name: [''],
      mode: [[]],
      content: this.contentCtrl,
    })
    this.route.params.subscribe((params) => {
      this.currentPatternId = params['id'];
      this.getEntry();
    });
  }

  getEntry() {
    this.textPatternService.getPattern(this.currentPatternId).subscribe({
      next: (data) => {
        this.textPattern = data;
        this.references = this.sharedService.extractReferences(data)['Verweise'];
        this.setForm(data);
        this.toggleEditingTools(false);
      },
      error: (error) => {
        this.notificationService.openSnackBar(error);
      }
    });
  }

  setForm(data: TextPatternCreationDto) {
    this.formGroup.controls['name'].setValue(data.name);
    this.formGroup.controls['mode'].setValue(data.mode);
  }

  toggleEditingTools(change: boolean) {
    if (change) {
      this.displayEditingTools = !this.displayEditingTools;
    }
  }

  saveChanges() {
    const formValue = this.formGroup.value;
    const pattern = new TextPatternCreationDto(
      this.textPattern.id,
      formValue.name,
      formValue.mode,
      this.markdownEditor.getMarkdown(),
      this.sharedService.getIds(this.references?.vocabCategories),
      this.sharedService.getIds(this.references?.vocabEntries),
      this.sharedService.getIds(this.references?.functionalGrammarCategories),
      this.sharedService.getIds(this.references?.functionalGrammarEntries),
      this.sharedService.getIds(this.references?.systemicGrammarCategories),
      this.sharedService.getIds(this.references?.systemicGrammarEntries),
      this.sharedService.getIds(this.references?.textPatterns),
      this.sharedService.getIds(this.references?.textTypes),
      this.sharedService.getIds(this.references?.detailedCanDoStatementCategories),
      this.sharedService.getIds(this.references?.detailedCanDoStatementEntries),
      this.sharedService.getIds(this.references?.globalCanDoStatementCategories),
      this.sharedService.getIds(this.references?.globalCanDoStatementEntries)
    );
    this.textPatternService.updatePattern(this.currentPatternId, pattern).subscribe(
      data => {
        this.textPattern = data;
        this.notificationService.openSnackBar('Textmuster erfolgreich gespeichert.');
      }, error => {
        this.notificationService.openSnackBar(error);
      }
    );
  }

  updateReferences() {
    const pattern = new TextPatternCreationDto(
      this.textPattern.id,
      this.textPattern.name,
      this.textPattern.mode,
      this.textPattern.content,
      this.sharedService.getIds(this.references?.vocabCategories),
      this.sharedService.getIds(this.references?.vocabEntries),
      this.sharedService.getIds(this.references?.functionalGrammarCategories),
      this.sharedService.getIds(this.references?.functionalGrammarEntries),
      this.sharedService.getIds(this.references?.systemicGrammarCategories),
      this.sharedService.getIds(this.references?.systemicGrammarEntries),
      this.sharedService.getIds(this.references?.textPatterns),
      this.sharedService.getIds(this.references?.textTypes),
      this.sharedService.getIds(this.references?.detailedCanDoStatementCategories),
      this.sharedService.getIds(this.references?.detailedCanDoStatementEntries),
      this.sharedService.getIds(this.references?.globalCanDoStatementCategories),
      this.sharedService.getIds(this.references?.globalCanDoStatementEntries)
    );
    this.textPatternService.updatePattern(this.currentPatternId, pattern).subscribe({
      next: data => {
        this.textPattern = data;
        this.notificationService.openSnackBar('Textmuster erfolgreich gespeichert.');
      },
      error: error => {
        this.notificationService.openSnackBar(error);
      }
    });
  }

  handleReferenceChange($event: References) {
    this.references = $event;
    this.updateReferences()
  }
}
